import styled, { css } from "styled-components";
import { MAP_STATUS_COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";

export type MapStatusType = {
  [key: string]: number;
};

export const changeColorMapMarkerStatus = (status: MapStatusType) => {
  let labelcolor = MAP_STATUS_COLORS.HEALTHY;

  if (status.warningCount > 0) {
    labelcolor = MAP_STATUS_COLORS.WARNING;
  }

  if (status.assignCount > 0) {
    labelcolor = MAP_STATUS_COLORS.ASSIGNED;
  }

  if (status.alertCount > 0) {
    labelcolor = MAP_STATUS_COLORS.ALERT;
  }
  if (status.criticalCount > 0) {
    labelcolor = MAP_STATUS_COLORS.CRITICAL;
  }
  return labelcolor;
};

export const MarkerWrapper = styled.div<{
  status: MapStatusType;
}>`
  .marker-circle-bg {
    position: absolute;
  }

  .circle-animation {
    width: 150px !important;
    height: 150px !important;
    border-radius: 50%;
  }

  .marker-circle-bg.circle-animation {
    pointer-events: none;
    background-color: ${(props) => changeColorMapMarkerStatus(props.status)};
    z-index: -1;
    opacity: 0.5;
    animation: pulse 1.5s infinite;
  }
  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.4);
      opacity: 0.6;
    }
  }

  @keyframes clusterPulse {
    0%,
    100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.7;
    }
    50% {
      transform: translate(-50%, -50%) scale(var(--cluster-scale));
      opacity: 0.6;
    }
  }

  @keyframes clusterAnimatePulse {
    0%,
    100% {
      transform: translate(-50%, -50%) scale(0.5);
      opacity: 0.7;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.1);
      opacity: 0.6;
    }
  }
`;
